export default class ProductSpecificationSwiper extends HTMLElement {
  static get observedAttributes() {
    return ['active-data-index'];
  }

  #textArea = null;
  #mediaArea = null;
  #textAreaElements = null;
  #mediaAreaSlideShow = null;

  constructor() {
    super();

    if (!theme.config.isTouch || Shopify.designMode) {
      Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    } else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }
  }

  connectedCallback() { }

  init() {
    this.#textArea = this.querySelector('[data-text-area]');
    this.#mediaArea = this.querySelector('[data-media-area]');

    this.#textAreaElements = this.#textArea?.querySelectorAll('[data-index]')
    this.#mediaAreaSlideShow = this.#mediaArea?.querySelector('iseecoo-slide-show');

    if (this.#textAreaElements && this.#mediaAreaSlideShow) {
      const initialIndex = Array.from(this.#textAreaElements).at(0).dataset.index;
      this.activeDataIndex = initialIndex;
      this.#mediaAreaSlideShow.select(initialIndex);
      this.bindTextAreaEvents();
      this.#mediaAreaSlideShow.addEventListener('slider:change', this._handleSlideChange.bind(this));
    } else {
      console.warn('textArea or mediaArea or their slideshow is missing.');
    }
  }

  bindTextAreaEvents() {
    if (this.#textAreaElements?.length > 0) {
      console.log(this.#textAreaElements)
      Array.from(this.#textAreaElements).forEach((element) => {

        element.addEventListener('click', this._handleTextAreaChange.bind(this));
        if (element.dataset.index === this.activeDataIndex) {
          element.classList.add('active');
        }
      });
    }
  }

  _handleTextAreaChange(evt) {
    
    const element = evt.currentTarget;
    const index = element.dataset.index;

    if (index === this.activeDataIndex) return;

    this.activeDataIndex = index;
    this.#mediaAreaSlideShow.select(index);
  }

  _handleSlideChange(evt) {
    const newIndex = evt.detail.currentDataIndex;

    if (!newIndex || typeof newIndex !== 'string' || !this.#textAreaElements || !Array.from(this.#textAreaElements).find(el => el.dataset.index === newIndex)) {
      return;
    }

    if (newIndex === this.activeDataIndex) return;

    this.activeDataIndex = newIndex;
  }

  // 监听属性变化
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'active-data-index' && oldValue !== newValue) {
      this.updateActiveState();
      this.dispatchEvent(new CustomEvent('active-data-index-changed', {
        detail: { activeDataIndex: newValue }
      }));
    }
  }

  updateActiveState() {
    if (this.#textAreaElements?.length > 0) {
      Array.from(this.#textAreaElements).forEach((el) => {
        if (el.dataset.index === this.activeDataIndex) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    }
  }

  get activeDataIndex() {
    return this.getAttribute('active-data-index');
  }

  set activeDataIndex(value) {
    this.setAttribute('active-data-index', value);
  }
}
